module.exports = __webpack_public_path__ + "img/slider-image-sm-11.e2b75d12.jpg";